// extracted by mini-css-extract-plugin
export var phone = "_4m-0";
export var phoneDragging = "_4m-1";